import { PricingPlan } from '@services/appsync/types';
import { createStore, useStore } from 'zustand';

interface PricingPlanModelActions {
  getFeeValue: (pricingPlan: PricingPlan) => number;
  getFriendlyFrequencyName: (pricingPlan: PricingPlan) => string;
  getFriendlyName: (pricingPlan: PricingPlan) => string;
}

export const PricingPlanModel = createStore<PricingPlanModelActions>(() => ({
  getFeeValue(pricingPlan) {
    switch (pricingPlan) {
      case PricingPlan.FIVE_DOLLARS_UNDER_5K:
        return 5;
      case PricingPlan.FIFTY_DOLLARS_PER_YEAR_UNDER_5K:
        return 50;
      default:
        return 0;
    }
  },
  getFriendlyFrequencyName(pricingPlan) {
    switch (pricingPlan) {
      case PricingPlan.FIVE_DOLLARS_UNDER_5K:
        return 'Monthly';
      case PricingPlan.FIFTY_DOLLARS_PER_YEAR_UNDER_5K:
        return 'Yearly';
      default:
        return 'n/a';
    }
  },
  getFriendlyName(pricingPlan) {
    switch (pricingPlan) {
      case PricingPlan.FIVE_DOLLARS_UNDER_5K:
        return '$5/month';
      case PricingPlan.FIFTY_DOLLARS_PER_YEAR_UNDER_5K:
        return '$50/year';
      default:
        return 'n/a';
    }
  },
}));

export function usePricingPlanModel(): PricingPlanModelActions;

export function usePricingPlanModel<T>(
  selector: (state: PricingPlanModelActions) => T,
  equals?: (a: T, b: T) => boolean,
): T;

export function usePricingPlanModel<T>(
  selector?: (state: PricingPlanModelActions) => T,
  equals?: (a: T, b: T) => boolean,
) {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return useStore(PricingPlanModel, selector!, equals);
}
